'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    modelClass: require('./model'),
    viewClass: require('./view'),

    name: 'fare_family_component',

    methods: {
        getFareFamilies(requestData) {
            this.model.fetchFareFamilies(requestData);
        },
        getFareFamiliesFromSession() {
            this.model.getFareFamiliesFromSession();
        },
        setFareFamiliesMeta(data) {
            this.model.setFareFamiliesMeta(data);
        },
        trackOpenFare() {
            this.model.sendOpenFaresTracking();
        },
    },
});
